// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"abc61bf0","947":"4f50737c"}[chunkId] + ".chunk.js";
};